<script setup>
import { Link } from '@inertiajs/vue3';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'
import Vue3Html2pdf from 'vue3-html2pdf';
import VoucherPdf from "../Pages/Bookings/voucher.vue";
import { ref } from 'vue';
import Loading from 'vue-loading-overlay';

const props = defineProps({
    bookingById: Object,
    invoices: Object,
    menu: String,
    agent: Object,
});
let html2Pdf = ref();
let isLoading = ref(false);

let options = {
    margin: 0,
    image: { type: 'jpeg', quality: 0.98 },
    filename: props.bookingById.booking_no + '.pdf',
    html2canvas: { scale: 2, letterRendering: true },
    jsPDF: { unit: 'in', format: 'a3', orientation: 'p' },
};

//pdf download progress
function onProgress(state) {
    if (state > 0 && state < 100) {
        isLoading.value = true;
    } else {
        isLoading.value = false;
    }
}

function reinstateBooking(value) {
    new Swal({
        title: 'Reinstating Booking',
        text: "This booking will be reinstated and goes to a pending state.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/bookings/reinstate/' + value;
            }, 300);
        }
    })
}

function generateVoucherPdf() {
    html2Pdf.value.generatePdf();
}

</script>
<template>
    <div class="vld-parent">
        <Loading v-model:active="isLoading" :color="'#696cff'" />
    </div>
    <div class="row">
        <div class="col-12">
            <div class="card mb-4">
                <div class="user-profile-header-banner">
                    <img :src="'/fetchImages/d?id=' + bookingById.hotel.id + '&type=cover&w=1388&h=250&fit=crop&blur=50'"
                        :alt="bookingById.hotel.name" class="rounded-top" />
                </div>
                <div class="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                    <div class="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                        <img :src="'/fetchImages/d?id=' + bookingById.hotel.id + '&type=cover&w=200&h=200&fit=crop'"
                            :alt="bookingById.hotel.name"
                            class="d-block h-auto ms-0 ms-sm-4 rounded user-profile-img" />
                    </div>
                    <div class="flex-grow-1 mt-3 mt-sm-5">
                        <div
                            class="d-flex align-items-md-end align-items-sm-start align-items-center justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                            <div class="user-profile-info">
                                <h4>{{ bookingById.booking_no }}</h4>
                                <ul
                                    class="list-inline mb-0 d-flex align-items-center flex-wrap justify-content-sm-start justify-content-center gap-2">
                                    <li class="list-inline-item"><i class="bx bx-map"></i>
                                        {{ bookingById.hotel.name }} - {{ bookingById.hotel.country.name }}
                                    </li>
                                    <li class="list-inline-item">
                                        <i v-for="n in bookingById.hotel.star_rating"
                                            class="bx bxs-star text-warning"></i>
                                    </li>
                                    <li>
                                        <span v-if="bookingById.status == 'Pending'" class="badge bg-label-dark">
                                            <i class="bx bxs-bookmark"></i> {{ bookingById.status }}
                                        </span>
                                        <span v-if="bookingById.status == 'Confirmed'" class="badge bg-label-info">
                                            <i class="bx bxs-bookmark"></i> {{ bookingById.status }}
                                        </span>
                                        <span v-if="bookingById.status == 'Paid'" class="badge bg-label-success">
                                            <i class="bx bxs-bookmark"></i> {{ bookingById.status }}
                                        </span>
                                        <span v-if="bookingById.status == 'Cancelled'" class="badge bg-label-danger">
                                            <i class="bx bxs-bookmark"></i> {{ bookingById.status }}
                                        </span>
                                    </li>
                                    <li>
                                        <Link
                                            v-if="bookingById.status == 'Pending' && bookingById.status !== 'Cancelled' && menu == 'details' && $page.props.user.permissions.includes('confirm-bookings')"
                                            class="btn btn-secondary" data-bs-toggle="modal" href="#"
                                            data-bs-target="#bookingComfirmModal">
                                        <b>Confirm Booking</b>
                                        </Link>
                                        <Link
                                            v-if="bookingById.status !== 'Pending' && bookingById.status !== 'Cancelled' && menu == 'details' && $page.props.user.permissions.includes('download-booking-voucher')"
                                            class="btn btn-info" @click="generateVoucherPdf()" href="#"><b>Booking
                                            Voucher</b>
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div class="btn-group" id="dropdown-icon-demo" v-if="menu == 'details'">
                                <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bx bx-menu bx-tada"></i> Actions
                                </button>
                                <ul class="dropdown-menu">
                                    <li v-if="bookingById.status !== 'Cancelled' && bookingById.status !== 'Paid'">
                                        <Link :href="'/bookings/edit/' + bookingById.id" href="#"
                                            v-if="$page.props.user.permissions.includes('edit-bookings')"
                                            class="dropdown-item d-flex align-items-center"><i
                                            class="bx bx-chevron-right scaleX-n1-rtl"></i>Edit Booking
                                        </Link>
                                    </li>
                                    <li v-if="bookingById.status !== 'Cancelled'">
                                        <Link class="dropdown-item d-flex align-items-center"
                                            v-if="$page.props.user.permissions.includes('update-booking-flight-details')"
                                            data-bs-toggle="modal" data-bs-target="#addEditFlightDetailsModal" href="#">
                                        <i class="bx bx-chevron-right scaleX-n1-rtl"></i>Update Flight Details
                                        </Link>
                                    </li>
                                    <li v-if="bookingById.status !== 'Cancelled'">
                                        <Link class="dropdown-item d-flex align-items-center"
                                            v-if="$page.props.user.permissions.includes('update-booking-resort-amount')"
                                            data-bs-toggle="modal" data-bs-target="#updateResortAmountModal" href="#"><i
                                            class="bx bx-chevron-right scaleX-n1-rtl"></i>Update Resort Amount
                                        </Link>
                                    </li>
                                    <hr>
                                    <li v-if="bookingById.status !== 'Cancelled'">
                                        <Link class="dropdown-item d-flex align-items-center text-danger"
                                            v-if="$page.props.user.permissions.includes('cancel-bookings')"
                                            data-bs-toggle="modal" href="#" data-bs-target="#cancelBookingModal"><i
                                            class="bx bx-chevron-right scaleX-n1-rtl"></i>Cancel Booking
                                        </Link>
                                    </li>
                                    <li v-else>
                                        <Link class="dropdown-item d-flex align-items-center text-danger"
                                            v-if="$page.props.user.permissions.includes('reinstate-bookings')"
                                            @click="reinstateBooking(bookingById.id)"><i
                                            class="bx bx-chevron-right scaleX-n1-rtl" href="#"></i>Reinstate Booking
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <button type="button" class="btn btn-primary"
                                v-if="menu == 'clients' && bookingById.status !== 'Cancelled' && $page.props.user.permissions.includes('add-booking-clients')"
                                data-bs-toggle="modal" data-bs-target="#addClientModal"> <i
                                    class='bx bx-plus bx-tada'></i>
                                Add Client
                            </button>
                            <div class="btn-group" id="dropdown-icon-demo"
                                v-if="menu == 'accounts' && bookingById.status !== 'Cancelled'">
                                <button type=" button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bx bx-menu bx-tada"></i> Actions
                                </button>
                                <ul class="dropdown-menu">
                                    <li
                                        v-if="bookingById.status !== 'Cancelled' && bookingById.status !== 'Paid' && props.invoices.length < 2">
                                        <Link class="dropdown-item d-flex align-items-center"
                                            v-if="$page.props.user.permissions.includes('add-proforma-invoice')"
                                            data-bs-toggle="modal" data-bs-target="#addInvoiceModal" href="#"><i
                                            class="bx bx-chevron-right scaleX-n1-rtl"></i>Create Proforma</Link>
                                    </li>
                                    <li v-if="bookingById.status !== 'Cancelled'">
                                        <Link class="dropdown-item d-flex align-items-center"
                                            v-if="$page.props.user.permissions.includes('add-tax-invoice')"
                                            data-bs-toggle="modal" data-bs-target="#addTaxInvoiceModal" href="#"><i
                                            class="bx bx-chevron-right scaleX-n1-rtl"></i>Create Tax Invoice</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--/ Header -->

    <!-- Navbar pills -->
    <div class="row">
        <div class="col-md-12">
            <ul class="nav nav-pills flex-column flex-sm-row mb-4">
                <li class="nav-item">
                    <Link class="nav-link" :class="{ 'active': $page.component.startsWith('Bookings') }"
                        :href="'/bookings/show/' + bookingById.id" preserve-scroll><i class="bx bx-info-circle"></i>
                    Details</Link>
                </li>
                <li class="nav-item">
                    <Link class="nav-link" :class="{ 'active': $page.component.startsWith('Clients') }"
                        v-if="$page.props.user.permissions.includes('view-booking-clients')"
                        :href="'/bookings/clients/' + bookingById.id" preserve-scroll><i class=" bx bx-user"></i>
                    Clients</Link>
                </li>
                <li class="nav-item">
                    <Link class="nav-link" :class="{ 'active': $page.component.startsWith('Invoices') }"
                        v-if="$page.props.user.permissions.includes('view-invoicing')"
                        :href="'/bookings/invoices/' + bookingById.id" preserve-scroll>
                    <i class="bx bx-dollar-circle"></i>
                    Invoicing</Link>
                </li>
            </ul>
        </div>
    </div>
    <!--/ Navbar pills -->
    <div v-if="bookingById.client.length == 0" class="alert alert-danger d-flex" role="alert">
        <span class="badge badge-center rounded-pill bg-danger border-label-danger p-3 me-2"><i
                class="bx bxs-bell-ring fs-6"></i></span>
        <div class="d-flex flex-column ps-1">
            <h6 class="alert-heading d-flex align-items-center fw-bold mb-1">Alert</h6>
            <span>No clients added to this booking. Please add clients to this booking!</span>
        </div>
    </div>

    <div v-if="bookingById.arrival_flight == null || bookingById.departure_flight == null"
        class="alert alert-danger d-flex" role="alert">
        <span class="badge badge-center rounded-pill bg-danger border-label-danger p-3 me-2"><i
                class="bx bxs-bell-ring fs-6"></i></span>
        <div class="d-flex flex-column ps-1">
            <h6 class="alert-heading d-flex align-items-center fw-bold mb-1">Alert</h6>
            <span>Flight details not updated. Please update flight details!</span>
        </div>
    </div>

    <Vue3Html2pdf v-if="menu == 'details'" :show-layout="false" :enable-download="true" :preview-modal="false"
        :manual-pagination="true" pdf-content-width="1500px" :html-to-pdf-options="options"
        @progress="onProgress($event)" ref="html2Pdf">
        <template v-slot:pdf-content>
            <VoucherPdf :bookingById="bookingById" :agent="agent" />
        </template>
    </Vue3Html2pdf>
</template>